export default "__VITE_ASSET__02e1b573__"